
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref
} from 'vue'
import { useStore } from '@/composables/use-store'
import FaqComponent from './FaqComponent.vue'
import SocialLinksComponent from './SocialLinksComponent.vue'
import SaveChangesBar from '@/components/SaveChangesBar.vue'

export default defineComponent({
  name: 'CampaignComponents',
  components: {
    FaqComponent,
    SocialLinksComponent,
    SaveChangesBar
  },
  setup () {
    const store = useStore()
    const faqRef = ref()
    const socialLinksRef = ref()
    const saving = ref(false)
    const unsavedChanges = ref(false)

    const components = computed(() => store.getters['components/components'])
    const appHelper = computed(() => store.getters['apps/currentHelper'])
    const defaultComponents = computed<string[]>(() => appHelper.value?.components?.default_components || [])
    const faqEnabled = computed(() => defaultComponents.value.includes('faq'))
    const socialLinksEnabled = computed(() => defaultComponents.value.includes('social_links'))

    onMounted(() => {
      store.dispatch('components/LOAD_COMPONENTS')
    })

    const unsubscribe = store.subscribe((mutation: any) => {
      if (
        mutation.type === 'campaigns/UPDATE_TRANSLATION_MESSAGE' &&
        ((faqEnabled.value && mutation.payload.messageId.startsWith('faq.entries.')) ||
          (socialLinksEnabled.value && mutation.payload.messageId.startsWith('social_links.')))
      ) {
        unsavedChanges.value = true
      }
    })

    onBeforeUnmount(() => {
      unsubscribe()
    })

    const save = async () => {
      saving.value = true
      try {
        if (faqEnabled.value) {
          const faqData = faqRef.value?.getComponentData()
          if (faqData) {
            await store.dispatch('components/SAVE_COMPONENT', faqData)
          }
        }
        if (socialLinksEnabled.value) {
          const socialLinksData = socialLinksRef.value?.getComponentData()
          if (socialLinksData) {
            await store.dispatch('components/SAVE_COMPONENT', socialLinksData)
          }
        }
        const campaign = store.getters['campaigns/current']
        await store.dispatch('campaigns/EDIT_CURRENT', {
          i18n: campaign.data.i18n
        })
        unsavedChanges.value = false
      } finally {
        saving.value = false
      }
    }

    return {
      components,
      faqEnabled,
      socialLinksEnabled,
      faqRef,
      socialLinksRef,
      saving,
      unsavedChanges,
      save
    }
  }
})
